$(".itemDelete").on("click", function (e) {
    e.preventDefault();

    const action = $(this).data("delete-action");

    const ids = $("tbody input[name='id[]']:checked").map(function () {
        return $(this).val();
    }).get();

    if (!ids.length) {
        window.ui.alert.warning("선택된 항목이 없습니다.");
        return;
    }

    window.ui.confirm.danger({
        title: "삭제 확인",
        text: "선택하신 항목을 삭제하시겠습니까?",
        confirmButtonText: "삭제",
        cancelButtonText: "취소",
    }).then((result) => {
        if (!result.isConfirmed) return;

        $.redirect(action, {
            ids,
            ...window.csrf_token
        }, "post");
    });
});